import { useTranslation } from "react-i18next";
import { HttpError } from "./HttpError";

export const Error404 = () => {
  const { t } = useTranslation();

  return <HttpError statusCode={404} message={t("error::Page not found")} />;
};
